<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
              <el-form-item label="活动名称：">
                <el-input @keyup.enter.native="searchLoad" v-model.trim="formInlineTmp.name" placeholder="请输入活动名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="开始时间：">
                <el-date-picker style="width:193px;"
                  class="time-picker"
                  v-model="formInlineTmp.start_time"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间：">
                <el-date-picker style="width:190px;"
                  class="time-picker"
                  v-model="formInlineTmp.end_time"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="活动状态：">
                <el-select v-model="formInlineTmp.status" placeholder="请选择">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="pushToPage" class="add-btn btn-right" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
        <el-row class="import-data-title table-first-style">
          <el-table
            :data="tableData"
            v-loading="loading"
            class="table">
            <el-table-column
              prop="name"
              label="活动名称">
              <template slot-scope="scope">
                <div class="op-link" @click="pushToActivityPage(scope.row.id)">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width='80'
              prop="status"
              label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 0" style="color: orange;font-size:12px">未开始</span>
                <span v-if="scope.row.status === 1" style="color: #05B324;font-size:12px">运行中</span>
                <span v-if="scope.row.status === 2" style="color: #FF2B2B;font-size:12px">已禁用</span>
                <span v-if="scope.row.status === 3" style="color: #999;font-size:12px">已过期</span>
              </template>
            </el-table-column>
            <el-table-column
              width='120'
              label="抽奖/中奖人次">
              <template slot-scope="scope">
                {{ scope.row.draw_count }} / {{ scope.row.prize_count }}
              </template>
            </el-table-column>
            <!--<el-table-column-->
              <!--width="100"-->
              <!--label="创建时间">-->
               <!--<template slot-scope="scope">-->
                <!--{{ scope.row.create_time | formatDate }}-->
              <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column
              width='135'
              label="开始时间">
              <template slot-scope="scope">
                {{ scope.row.start_time | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              width='135'
              label="结束时间">
              <template slot-scope="scope">
                {{ scope.row.end_time | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              width='70'
              label="二维码">
              <template slot-scope="scope">
                  <!-- <qriously :value="scope.row.lottery_url" :size="100" style="margin-left: px;" /> -->
                  <img @click="showQRcode(scope.row.lottery_url)" src="/static/img/erweima.png" width="30px">
              </template>
            </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <div class="op-link" @click="copyAcivityAction(scope.row.id)">
                    复制
                  </div>
                  <div class="op-link" v-if="scope.row.status === 0">
                    <router-link :to="{ name: 'editActivity', query: { id: scope.row.id }}">
                      编辑
                    </router-link>
                  </div>
                  <div class="op-link" v-if="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 3">
                    <router-link :to="{ name: 'activityStatistics', query: { id: scope.row.id }}">
                      统计
                    </router-link>
                  </div>
                  <div class="op-link" v-if="scope.row.status === 1" @click="stopActivityAction(scope.row.id)">
                    禁用
                  </div>
                  <div class="op-link" v-if="scope.row.status === 0" @click="beginActivityAction(scope.row.id)">
                    开始
                  </div>
                  <div class="op-link" v-if="scope.row.status === 0 || scope.row.status === 3" @click="deleteAction(scope.row.id)">
                    删除
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-foot">
            <el-pagination
              class="table-foot-pagination"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="limit"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
          <!--添加二维码分组弹窗-->
          <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="qrCodedialog" width="620px">
            <el-input id="copyObj" class="qrcode-show-input" type="text" v-model.trim="qrCodeUrl" auto-complete="off" placeholder=""></el-input>
            <el-button class="dialog-confirm-btn" @click="getUrl" style="margin-left: 15px;color: #fff">复制链接</el-button>
            <!--<p style="word-break:break-all;">-->
              <!--{{ qrCodeUrl }}-->
            <!--</p>-->
            <qriously :value="qrCodeUrl" :size="240"/>
            <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
              <el-button class="dialog-cancel-btn" @click="qrCodedialog = false" style="margin-left: 20px">关 闭</el-button>
            </div> -->
          </el-dialog>
        </el-row>
    </div>
</template>
<script>
import { getActivityList, deleteActivity, editActivity, beginActivity, copyAcivity, stopActivity } from '@/api/customer.js'
export default {
  name: 'activityList',
  data () {
    return {
      loading: true,
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未开始',
          value: '0'
        },
        {
          label: '运行中',
          value: '1'
        },
        {
          label: '已禁用',
          value: '2'
        },
        {
          label: '已过期',
          value: '3'
        }
      ],
      qrCodedialog: false,
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {
      },
      formInline: {
      },
      qrCodeUrl: '',
      limit: 10
    }
  },
  methods: {
    // 获取二维码地址
    getUrl() {
      let url = document.querySelector('#copyObj')
      url.select() // 选择对象
      document.execCommand('Copy')
    },
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    pushToActivityPage(id) {
      router.push({name: 'activityDetails', query: { id: id }})
    },
    showQRcode(url) {
      this.qrCodedialog = true
      this.qrCodeUrl = url
    },
    pushToPage() {
      router.push('/home/add-activity')
    },
    // 开始活动
    beginActivityAction(id) {
      beginActivity(id).then((res) => {
        if (res.data.code === 0) {
          this.getData()
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    stopActivityAction(id) {
      let ids = []
      ids.push(id)
      let idStr = ids.toString()
      stopActivity(ids).then(res => {
        if (res.data.code === 0) {
          this.getData()
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 删除活动
    deleteAction(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivity(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除活动成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    copyAcivityAction(id) {
      copyAcivity(id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getData() {
      this.loading = true
      getActivityList(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  height:40px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
